module.exports = __webpack_public_path__ + "static/media/game-forewordbutton.1997a9e2.png";